import { Component } from "@opten/compiler/metadata/component";
import { hasClass } from '@opten/dom/has-class';
import { dispatchCustomEvent } from "@opten/events/dispatch-custom-event";

@Component({ className: "js-form-total" })
export class FormTotalComponent {
	private inputs: HTMLInputElement[];

	constructor(private total: HTMLElement) {
		const form = total.closest("form") as HTMLElement;
		const group = this.total.getAttribute("data-group");
		this.inputs = (
			Array.from(
				form.querySelectorAll(
					`[data-group="${group}"],[name="${group}"]`,
				),
			) as HTMLInputElement[]
		).filter((input) => hasClass(input, "js-form-total") == false || input.getAttribute("name") === group);
		if (this.inputs && this.inputs.length > 0) {
			this.inputs.forEach((input) => {
				input.addEventListener("change", () => this.updateTotal());
				input.addEventListener("input", () => this.updateTotal());
			});
			this.updateTotal();
		}
	}

	private updateTotal() {
		let total = 0;
		this.inputs.forEach((input) => {
			const factor = parseFloat(input.getAttribute("data-factor") || "1");
			total += factor * parseInt(input.value || "0");
		});
		if (this.total.nodeName === "INPUT") {
			(this.total as HTMLInputElement).value = total.toString();
			dispatchCustomEvent(this.total, "input");
		} else {
			this.total.innerHTML = total.toString();
		}
	}
}
